import { render, staticRenderFns } from "./ListModality.vue?vue&type=template&id=eb10675e"
import script from "./ListModality.vue?vue&type=script&lang=js"
export * from "./ListModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports